module.exports = __webpack_public_path__ + "static/media/twitter.e3ca3ccf.svg";